import { InternalMedFormIcon } from "../internal/MedFormIcon.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/med-form-icon/variants/MedFormInhalerIcon.tsx
const MedFormInhalerIcon = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(InternalMedFormIcon, {
		...props,
		svgFile: "inhaler-icon.svg",
		alt: t("medicationForm.inhaler")
	});
};

//#endregion
export { MedFormInhalerIcon };